import React, { AnchorHTMLAttributes } from 'react';

const Link = ({ children, href }: AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a href={href} rel="noopener noreferrer" target="_blank">
    {children}
  </a>
);

export default Link;
